import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../components'
const textLink = {
  home: 'Home',
  companyProfile: 'Company Profile',
  userManagement: 'User Management',
  createUser: 'Create User',
  editUser: 'Edit User',
  supplierManagement: 'Supplier Management',
  uploadSupplier: 'Upload Supplier',
  editSupplier: 'Edit Supplier',
  supplierDiscovery: 'Supplier Discovery',
  supplierInformation: 'Supplier Information',
  riskManagement: 'Risk Level Management',
  regulatory: 'Regulatory',
  sustainability: 'Sustainability Management',
  comprehensiveAssessment: 'Comprehensive Assessment Management',
  sourcingProject: 'Sourcing Project',
  createEvent: 'Creation',
  sourcingEvent: 'Sourcing Event',
  sourcingProjectDetail: 'Project Details',
  sourcingCompareEvent: 'Compare Event',
}
const funcLinkHome = () => {
  return (
    <Button className="breadcrumb">
      <span>
        <Link to="/">{textLink.home}</Link>
      </span>
    </Button>
  )
}
const funcLinkCompanyProfile = () => {
  return (
    <Button className="breadcrumb current">
      <span>{textLink.companyProfile}</span>
    </Button>
  )
}
const funcLinkUserManagement = (link = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to="/user-management-buyer">{textLink.userManagement}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.userManagement}</span>
      </Button>
    )
  }
}
const funcCreateUser = () => {
  return (
    <Button className="breadcrumb current">
      <span>{textLink.createUser}</span>
    </Button>
  )
}
const funcEditUser = () => {
  return (
    <Button className="breadcrumb current">
      <span>{textLink.editUser}</span>
    </Button>
  )
}
const funcSupplierManagement = (link = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to="/supplier-management-buyer">
            {textLink.supplierManagement}
          </Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.supplierManagement}</span>
      </Button>
    )
  }
}
const funcUploadSupplier = (link = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to="/upload-supplier-form-buyer">
            {textLink.uploadSupplier}
          </Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.uploadSupplier}</span>
      </Button>
    )
  }
}
const funcEditSupplier = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.editSupplier}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.editSupplier}</span>
      </Button>
    )
  }
}
const funcSupplierDiscovery = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.supplierDiscovery}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.supplierDiscovery}</span>
      </Button>
    )
  }
}
const funcSupplierInformation = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.supplierInformation}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.supplierInformation}</span>
      </Button>
    )
  }
}
const funcRiskManagement = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.riskManagement}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.riskManagement}</span>
      </Button>
    )
  }
}
const funcRegulatory = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.regulatory}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.regulatory}</span>
      </Button>
    )
  }
}
const funcSustainaBility = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sustainability}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sustainability}</span>
      </Button>
    )
  }
}
const funcComprehensiveAssessment = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.comprehensiveAssessment}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.comprehensiveAssessment}</span>
      </Button>
    )
  }
}
const funcSourcingProjects = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sourcingProject}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sourcingProject}</span>
      </Button>
    )
  }
}
const funcCreateEvent = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.createEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.createEvent}</span>
      </Button>
    )
  }
}
const funcSourcingEvent = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sourcingEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sourcingEvent}</span>
      </Button>
    )
  }
}
const funcSourcingEventEdit = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.createEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.createEvent}</span>
      </Button>
    )
  }
}
const funcSourcingEventsEdit = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.createEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.createEvent}</span>
      </Button>
    )
  }
}
const funcSourcingDetailFormEdit = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.createEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.createEvent}</span>
      </Button>
    )
  }
}
const funcSourcingProjectDetail = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sourcingProjectDetail}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sourcingProjectDetail}</span>
      </Button>
    )
  }
}
const funcSourcingCreateNewRound = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.createEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.createEvent}</span>
      </Button>
    )
  }
}
const funcSourcingCompareEvents = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sourcingCompareEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sourcingCompareEvent}</span>
      </Button>
    )
  }
}
const funcSourcingCompareEvent = (link = '', url = '') => {
  if (link) {
    return (
      <Button className="breadcrumb">
        <span>
          <Link to={url}>{textLink.sourcingCompareEvent}</Link>
        </span>
      </Button>
    )
  } else {
    return (
      <Button className="breadcrumb current">
        <span>{textLink.sourcingCompareEvent}</span>
      </Button>
    )
  }
}
export const companyProfile = [
  {
    home: funcLinkHome(),
  },
  {
    companyProfile: funcLinkCompanyProfile(),
  },
]
export const userManagement = [
  {
    home: funcLinkHome(),
  },
  {
    userManagement: funcLinkUserManagement(),
  },
]
export const userDetailFormBuyer = [
  {
    home: funcLinkHome(),
  },
  {
    userManagement: funcLinkUserManagement(true),
  },
  {
    createUser: funcCreateUser(),
  },
]
export const userEditFormBuyer = [
  {
    home: funcLinkHome(),
  },
  {
    userManagement: funcLinkUserManagement(true),
  },
  {
    editUser: funcEditUser(),
  },
]
export const supplierManagementBuyer = [
  {
    home: funcLinkHome(),
  },
  {
    supplierManagement: funcSupplierManagement(),
  },
]
export const uploadSupplierFormBuyer = [
  {
    home: funcLinkHome(),
  },
  {
    supplierManagement: funcSupplierManagement(true),
  },
  {
    uploadSupplier: funcUploadSupplier(),
  },
]
export const editSupplier = [
  {
    home: funcLinkHome(),
  },
  {
    supplierManagement: funcSupplierManagement(true),
  },
  {
    editSupplier: url => {
      return funcEditSupplier()
    },
  },
]
export const supplierDiscovery = [
  {
    home: funcLinkHome(),
  },
  {
    supplierDiscovery: url => {
      return funcSupplierDiscovery()
    },
  },
]
export const supplierInformation = [
  {
    home: funcLinkHome(),
  },
  {
    supplierDiscovery: url => {
      return funcSupplierDiscovery(true, url)
    },
  },
  {
    supplierInformation: url => {
      return funcSupplierInformation()
    },
  },
]
export const riskManagement = [
  {
    home: funcLinkHome(),
  },
  {
    riskManagement: url => {
      return funcRiskManagement()
    },
  },
]
export const regulatory = [
  {
    home: funcLinkHome(),
  },
  {
    regulatory: url => {
      return funcRegulatory()
    },
  },
]
export const sustainaBility = [
  {
    home: funcLinkHome(),
  },
  {
    sustainaBility: url => {
      return funcSustainaBility()
    },
  },
]
export const comprehensiveAssessment = [
  {
    home: funcLinkHome(),
  },
  {
    comprehensiveAssessment: url => {
      return funcComprehensiveAssessment()
    },
  },
]
export const sourcingProjects = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects()
    },
  },
]
export const sourcingProjectsCreateEvent = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    createEvent: url => {
      return funcCreateEvent()
    },
  },
]
export const sourcingDetailFormEdit = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingProjectDetail: url => {
      return funcSourcingProjectDetail(true, url)
    },
  },
  {
    sourcingDetailFormEdit: url => {
      return funcSourcingDetailFormEdit()
    },
  },
]
export const sourcingEvent = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingEvent: url => {
      return funcSourcingEvent()
    },
  },
]
export const sourcingEventEdit = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingEvent: url => {
      return funcSourcingEvent(true, url)
    },
  },
  {
    sourcingEventEdit: url => {
      return funcSourcingEventEdit()
    },
  },
]
export const sourcingEventsEdit = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingProjectDetail: url => {
      return funcSourcingProjectDetail(true, url)
    },
  },
  {
    sourcingEventsEdit: url => {
      return funcSourcingEventsEdit()
    },
  },
]
export const sourcingProjectDetail = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingProjectDetail: url => {
      return funcSourcingProjectDetail()
    },
  },
]
export const sourcingCreateNewRound = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingProjectDetail: url => {
      return funcSourcingProjectDetail(true, url)
    },
  },
  {
    sourcingEvent: url => {
      return funcSourcingEvent(true, url)
    },
  },
  {
    sourcingCreateNewRound: url => {
      return funcSourcingCreateNewRound()
    },
  },
  {
    sourcingDetailFormEdit: url => {
      return funcSourcingDetailFormEdit()
    },
  },
]
export const sourcingCompareEvents = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingProjects: url => {
      return funcSourcingProjects(true, url)
    },
  },
  {
    sourcingProjectDetail: url => {
      return funcSourcingProjectDetail(true, url)
    },
  },
  {
    sourcingCompareEvents: url => {
      return funcSourcingCompareEvents()
    },
  },
]
export const sourcingCompareEvent = [
  {
    home: funcLinkHome(),
  },
  {
    sourcingEvent: url => {
      return funcSourcingEvent(true, url)
    },
  },
  {
    sourcingCompareEvent: url => {
      return funcSourcingCompareEvent()
    },
  },
]
